import Head from 'next/head'
import React from 'react'

import { siftInit } from '@Globals/Sift/script'

export default () => (
  <Head>
    <script
      key="sift-init"
      dangerouslySetInnerHTML={{ __html: siftInit }}
      type="text/javascript"
    />
  </Head>
)
